<template>
    <div>
         <el-button type="primary" @click='submitInfo'>提交</el-button>
    </div>
</template>
<script>
export default {
    methods:{
        submitInfo(){
            // this.$router.replace({
            //     name:"撤除申请预览",
            //     params:{}
            // })
            this.$router.push('/applyIndex/viewCancel');
        }
    }

}
</script>



// WEBPACK FOOTER //
// applyCancel.vue?838223b8